import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AlertingFacade } from '@zero/alerting/domain';
import { CleverPushService, CleverPushTopic } from '@zero/feature-clever-push/base';
import { SwitchComponent } from '@zero/shared/ui-web-design-system';
import { from } from 'rxjs';

@Component({
  selector: 'alerting-clever-push-subscriptions',
  imports: [AsyncPipe, SwitchComponent],
  templateUrl: './clever-push-subscriptions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CleverPushSubscriptionsComponent implements OnInit {
  public readonly alertingFacade = inject(AlertingFacade);
  readonly #cleverPushService = inject(CleverPushService);
  public readonly featureEnabled$ = from(this.#cleverPushService.isFeatureEnabled());

  ngOnInit(): void {
    this.alertingFacade.loadTopics();
  }

  public changeSubscription(item: CleverPushTopic): void {
    this.alertingFacade.setTopicSubscription({ topicName: item.topicName, status: !item.value });
  }
}
